import { useEffect, useState } from 'react';

const navLinks = [
  { label: '本季新番', href: '#season' },
  { label: '新番推荐', href: '#recommend' },
  { label: '资源合集', href: '#collections' },
  { label: '追番时间表', href: '#schedule' },
  { label: '频道分类', href: '#genres' },
  { label: '排行榜', href: '#ranking' },
  { label: '常见问题', href: '#faq' },
];

interface NavbarProps {
  watchCount: number;
}

export default function Navbar({ watchCount }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between gap-4 px-4 md:px-8 h-16 md:h-20">
        <a
          href="#top"
          className={`flex items-center gap-2 shrink-0 cursor-pointer ${scrolled ? 'text-foreground-950' : 'text-background-50'}`}
        >
          <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-lg md:text-xl">
            <i className="ri-sparkling-2-fill"></i>
          </span>
          <span className="font-heading text-lg md:text-2xl leading-none">妖精动漫</span>
        </a>

        <ul className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className={`px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                    : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#watchlist"
            className="hidden sm:inline-flex items-center gap-2 rounded-md bg-primary-500 px-3.5 py-2 text-sm font-medium text-background-50 whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors dark:text-foreground-950"
          >
            <i className="ri-bookmark-line"></i>
            追番清单
            <span className="inline-flex items-center justify-center min-w-5 h-5 px-1 rounded-full bg-background-50 text-primary-700 text-xs font-bold">
              {watchCount}
            </span>
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-xl cursor-pointer ${
              scrolled ? 'text-foreground-950 bg-background-100' : 'text-background-50 bg-background-50/15'
            }`}
          >
            <i className={menuOpen ? 'ri-close-line' : 'ri-menu-2-line'}></i>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 py-3">
          <ul className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="block px-3 py-2.5 rounded-md text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-700 cursor-pointer"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#watchlist"
                onClick={() => setMenuOpen(false)}
                className="flex items-center justify-between px-3 py-2.5 rounded-md text-sm font-medium bg-primary-500 text-background-50 cursor-pointer dark:text-foreground-950"
              >
                <span>我的追番清单</span>
                <span className="inline-flex items-center justify-center min-w-5 h-5 px-1 rounded-full bg-background-50 text-primary-700 text-xs font-bold">
                  {watchCount}
                </span>
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}